import React, { lazy, Suspense, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LanguageSwitcher from "../shared/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { getUserType } from "../../utils/authutils";
import { HeaderNotification } from "../notification/HeaderNotification";
import TenderTaskSwitcher from "../shared/TenderTaskSwitcher";

const ShowPDF = lazy(() => import("../shared/ShowPDF"));

export default function Header({
  hasBack,
  navigation,
  mode,
  onModeChange,
  hasToggle,
  children,
  projectId,
  title,
}) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const userType = getUserType();
  const [openPDF, setOpenPDF] = useState(false);
  const [reportData, setReportData] = useState(null);
  const notShowHeader = ["contractor_worker", "admin", "customer"];
  const onlyShowTender = ["contractor_admin", "contractor_owner"];

  const handleBackClick = () => {
    const cameFromInternalNav = location.key !== "default";

    if (navigation) {
      if (cameFromInternalNav) {
        navigate(-1);
      } else {
        navigate(navigation, { replace: true });
      }
      return;
    }

    if (cameFromInternalNav) {
      navigate(-1);
      return;
    }

    if (location.pathname === "/dashboard/reports") {
      navigate("/", { replace: true });
    } else if (location.pathname.includes("/dashboard/reports/")) {
      navigate("/dashboard/reports", { replace: true });
    } else if (location.pathname.includes("/building/information")) {
      navigate(`/dashboard/projects/${projectId}`, { replace: true });
    } else if (userType === "customer") {
      navigate(`/dashboard/projects/${projectId}`, { replace: true });
    } else {
      navigate("/");
    }
  };

  const isLangSwitcherVisible =
    location.pathname.includes("/dashboard/reports/") ||
    location.pathname.includes("/dashboard/building/") ||
    location.pathname.includes("/dashboard/buildings/");

  return (
    <>
      <header className="h-16 flex items-center sticky top-0 z-10 bg-white">
        {hasBack && (
          <button
            className="flex items-center gap-2 px-3 py-1 rounded-full border hover:border-[#75B83E] active:border-[#75B83E] transition text-xs font-medium"
            onClick={handleBackClick}
            aria-label={t("main.buttons.back")}
          >
            <ArrowBackIcon fontSize="small" />
            <span>{t("main.buttons.back")}</span>
          </button>
        )}
        {title && <h1 className="text-2xl font-semibold">{title}</h1>}
        {children}
        <div className="ml-auto flex items-center gap-4">
          {onlyShowTender.includes(userType) && hasToggle && (
            <TenderTaskSwitcher value={mode} onChange={onModeChange} />
          )}
          {!notShowHeader.includes(userType) && <HeaderNotification />}
          {isLangSwitcherVisible && userType !== "client" && <LanguageSwitcher />}
        </div>
      </header>
      {reportData && openPDF && (
        <Suspense fallback={null}>
          <ShowPDF reportData={reportData} setOpenPDF={setOpenPDF} lang={i18n.language} />
        </Suspense>
      )}
    </>
  );
}
